




































































































import { Component, Vue } from "vue-property-decorator";
import { Action, Getter } from "vuex-class";
import fetch from "@/common/api/fetch";
import getUrlParam from '@/common/utils/getUrlParam';
import getActivityType from '@/common/utils/getActivityType';
import desensitizeName from '@/common/utils/desensitizeName';
import { AxiosPromiseData } from "@/common/interface";

@Component
export default class GachaRank extends Vue {
  @Getter("gachaTypeParameter") gachaTypeParameter!: object;
  @Getter("rankList") rankList!: Array<any>;
  @Getter("section") section!: any;
  @Action("changeRankList") changeRankList!: Function;
  getUrlParam: Function = getUrlParam;
  desensitizeName:Function = desensitizeName;

  mounted() {
    if (getUrlParam("type") === "share") {
      this.getRankList();
    }
  }
  getRankList() {
    const param = {
      activityId: getUrlParam("broadcastId"),
    };
    fetch.newpost('anon/gacha/getRankList', param)
    .then((res: AxiosPromiseData) => {
      this.changeRankList(res.result);
    });
  }

}
